import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_manufacturing_workshifts_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouse_id?: number }): 
  Promise<{ result: { Id?: number, Code?: string, DurationMinutes?: number, Friday?: boolean, Monday?: boolean, Name?: string, Saturday?: boolean, ShiftStartOffsetMinutes?: number, Sunday?: boolean, Thursday?: boolean, Tuesday?: boolean, WarehouseId?: number, Wednesday?: boolean }[] }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_workshifts_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouse_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Code?: string, DurationMinutes?: number, Friday?: boolean, Monday?: boolean, Name?: string, Saturday?: boolean, ShiftStartOffsetMinutes?: number, Sunday?: boolean, Thursday?: boolean, Tuesday?: boolean, WarehouseId?: number, Wednesday?: boolean }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_workshifts_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouse_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Code?: string, DurationMinutes?: number, Friday?: boolean, Monday?: boolean, Name?: string, Saturday?: boolean, ShiftStartOffsetMinutes?: number, Sunday?: boolean, Thursday?: boolean, Tuesday?: boolean, WarehouseId?: number, Wednesday?: boolean }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_workshifts_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouse_id?: number    }) {
      return false;
    }
}
